<template>
    <div>
      
      <vertical v-if="data.style=='vertical'" :form="data.majority"/>

      <horizontal v-if="data.style=='horizontal'" :form="data.majority"/>

    </div>
</template>

<script>
const Vertical = () => import(/* webpackChunkName: "quiz" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */'../Vertical.vue');
const Horizontal = () => import(/* webpackChunkName: "quiz" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ /* webpackPreload: true */'../Horizontal.vue');


export default {
  components: { Vertical, Horizontal },
  name: "Majority",
  props:['data'],
  mounted()
  {
    //setup auto next
    if( this.data.majority && this.data.style=='horizontal' )
    {
      for( var i in this.data.majority )
      {
        this.data.majority[i].auto_next = 1;
      }
    }
  }
}
</script>